<template lang="pug">
.page.right.active
  h5.center-align No messages
</template>

<script setup lang="ts">
</script>
